import createSelectors from './createSelectors';
import Recipient from '../models/Recipient';

const Select = createSelectors(Recipient, {});

export default Select;
